import intl from "react-intl-universal";
import {
  TbAdjustments,
  TbArrowsLeftRight,
  TbBolt,
  TbLink,
  TbList,
  TbPackages,
  TbQrcode,
  TbShieldCheck,
} from "react-icons/tb";
import { ShortcutCard } from "../../Atoms/ShortcutCard";
import { useAuth } from "../../../Contexts/AuthContext";

export const PixShortcutMenu = ({ onOpenQrReceive, onOpenTransfer }) => {
  const { hasPermission } = useAuth();

  const items = [
    {
      labelKey: "pix.keysManagement",
      icon: TbLink,
      path: "/pix/keys",
      permission: "pixview",
    },
    {
      labelKey: "pix.transferByPix",
      icon: TbArrowsLeftRight,
      onClick: onOpenTransfer,
      permission: "paypix",
    },
    {
      labelKey: "pix.batchBatches",
      icon: TbPackages,
      path: "/pix/lotes",
      permission: "pixview",
    },
    {
      labelKey: "pix.salesManagement",
      icon: TbList,
      path: "/pix/detalhes",
      permission: "receivepix",
    },
    {
      labelKey: "pix.transactionLimits",
      icon: TbAdjustments,
      path: "/pix/limites",
      permission: "pixview",
    },
    {
      labelKey: "pix.receiveByQr",
      icon: TbQrcode,
      onClick: onOpenQrReceive,
      permission: "receivepix",
    },
    {
      labelKey: "pix.dispute",
      icon: TbShieldCheck,
      path: "/pix/contestacao",
      permission: "pixview",
      comingSoon: true,
    },
    {
      labelKey: "pix.automaticPix",
      icon: TbBolt,
      path: "/pix/automatico",
      permission: "pixview",
      comingSoon: true,
    },
  ];

  const visible = items.filter(
    (item) => !item.permission || hasPermission(item.permission),
  );

  if (!visible.length) return null;

  return (
    <section className="mb-5 min-w-0 overflow-hidden">
      <h2 className="mb-3 text-sm font-bold text-brand-dark dark:text-gray-100">
        {intl.get("pix.quickActions")}
      </h2>
      <div className="shortcut-scroll-row">
        {visible.map(({ labelKey, icon, path, onClick, comingSoon }) => (
          <ShortcutCard
            key={labelKey}
            to={path}
            onClick={onClick}
            icon={icon}
            label={intl.get(labelKey)}
            disabled={comingSoon}
            badge={comingSoon ? intl.get("words.soon") : undefined}
          />
        ))}
      </div>
    </section>
  );
};
